import React, { useContext } from "react";
import { nFormatter } from "../../../../utils/utils";
import { StakeContext } from "../context";
import { SecondaryTile } from "./secondary-tile";

interface IAllStakedAmountProps { }

const AllStakedAmount: React.FunctionComponent<IAllStakedAmountProps> = (
  props
) => {
  const { currentContract } = useContext(StakeContext);

  return currentContract.fold(
    () => null,
    (statsActual) => (
      <SecondaryTile title="Locked Loyalty Points">
        $SKRT {nFormatter(statsActual.totalStakedTokens, 2)}
      </SecondaryTile>
    )
  );
};

export default AllStakedAmount;
